// extracted by mini-css-extract-plugin
export const eventsPageContainer = "events-module--eventsPageContainer--1BbQI";
export const events = "events-module--events--2A9P7";
export const eventsControls = "events-module--eventsControls--1-QWY";
export const eventControlsHeading = "events-module--eventControlsHeading--3QqSB";
export const eventsControlsButton = "events-module--eventsControlsButton--3UAm2";
export const eventsFilterSelect = "events-module--eventsFilterSelect--NfcJd";
export const eventsFilterSelectLabel = "events-module--eventsFilterSelectLabel--2DKjC";
export const eventsSelectedEventType = "events-module--eventsSelectedEventType--3KNqT";